import { Component, OnInit } from '@angular/core';
import { FetchBrowseProductTypeCategoriesService } from '../../services/products-browse-categories.service';
import { ProductBrowseService } from '../../services/products-browse.service';
import { ProductBrowseTypesService } from '../../services/products-browse-types.service';

@Component({
  selector: 'app-browse',
  templateUrl: './browse.component.html',
  styleUrls: ['./browse.component.scss']
})
export class BrowseComponent implements OnInit {

  constructor(
    private productBrowseTypesService: ProductBrowseTypesService,
    private fetchedBrowseCategoriesService: FetchBrowseProductTypeCategoriesService,
    private productBrowseService: ProductBrowseService,
  ) { }
  categories: any[] = [];
  selectedType: number = 0;
  selectedTypeIDs: any[] = [];
  products: any[] = [];
  productTypes: any[] = [];
  productTypeIds: any[] = [];
  category: string = '';
  name: string = '';
  currentPage: number = 1;
  itemsPerPage: number = 9;
  totalItems: any;

  async ngOnInit() {
    await this.initProductTypes();
    this.initCategories();
    this.fetchProducts();
  }

  async initProductTypes() {
    this.productBrowseTypesService.setParams({});
    this.productTypes = await this.productBrowseTypesService.make();
    this.productTypeIds = this.productTypes?.map(types => types.id);
  }

  async initCategories() {
    this.getType();
    this.fetchedBrowseCategoriesService.setParams({ types: this.selectedTypeIDs });
    this.categories = await this.fetchedBrowseCategoriesService.make();
  }

  getType() {
    if (this.selectedType == 0) {
      this.selectedTypeIDs = this.productTypeIds;
    } else {
      this.selectedTypeIDs = [];
      this.selectedTypeIDs = [Number(this.selectedType)];
    }
  }

  async fetchProducts() {
    this.getType();

    this.productBrowseService.setParams({
      types: this.selectedTypeIDs,
      category: this.category,
      name: this.name,
      page: this.currentPage,
      size: this.itemsPerPage
    });
    let response = await this.productBrowseService.make();
    this.products = response.result;
    this.totalItems = response.totalNumberOfRows;
  }

  typeChanged(event: any) {
    this.selectedType = event.value;
    this.initCategories();
  }

  onPageChanged(event: any) {
    this.currentPage = event.page;
    this.itemsPerPage = event.itemsPerPage;
    this.fetchProducts();
  }
}
